const checkMetaKey = (e) => {
  const os = window.navigator.userAgent

  if (os.indexOf("Win") != -1) {
    return e.ctrlKey
  } else {
    return e.metaKey
  }
}

export default checkMetaKey
